export default __webpack_public_path__ + "static/media/Plus.cd63edb2.svg";